/*
 * @Description: 字段验证
 * @Date: 2019-12-27 13:18:52
 * @LastEditTime: 2020-03-23 14:39:12
 */

// 账户
export const validateAccount = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('请输入邮箱/账号'));
  } else if (
    /^1(2|3|4|5|6|7|8|9)\d{9}$/.test(value) ||
    (value.indexOf('@') > -1 && value.length >= 4 && value.length <= 40) ||
    /^[a-zA-Z0-9_-]{6,18}$/.test(value)
  ) {
    callback();
  } else {
    callback(new Error('账号格式不正确'));
  }
}

// 验证码
export const validatecode = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('验证码不能为空'));
  } else {
    if (!/^[0-9]{6,6}$/.test(value)) {
      callback(new Error('验证码由6位数字构成'));
    } else {
      callback();
    }
  }
}

// 新密码
export const validateOldPsd = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('请输入原密码'));
  } else if (value.length < 8 || value.length > 18) {
    callback(new Error('密码长度限制8-18位'));
  } else if (value.indexOf(' ') > -1) {
    callback(new Error('密码不能含有空格'));
  } else {
    callback();
  }
}

// 新密码
export const validateNewPsd = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('请输入新密码'));
  } else if (value.length < 8 || value.length > 18) {
    callback(new Error('密码长度限制8-18位'));
  } else if (value.indexOf(' ') > -1) {
    callback(new Error('密码不能含有空格'));
  } else {
    callback();
  }
}

// 再次输入新密码
export const validateReNewpsd = (rule, value, callback, psd) => {
  if (value === '') {
    callback(new Error('请再输入一次新密码'));
  } else if (value !== psd) {
    callback(new Error('两次输入密码不一致'));
  } else {
    callback();
  }
}

// 手机号码
export const validateMobile = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('手机号码不能为空'))
  } else if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(value)) {
    callback(new Error('请输入正确格式的手机号码'))
  } else {
    callback();
  }
}

// 企业名称
export const validateOrgName = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('企业名称不能为空'))
  } else if (value.length > 50 || value.length < 2) {
    callback(new Error('请输入2到50位的企业名称'))
  } else {
    callback();
  }
}

// 联系人
export const validateContectName = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('联系人姓名不能为空'))
  } else if (value.length > 50 || value.length < 2) {
    callback(new Error('请输入2到50位的联系人姓名'))
  } else {
    callback();
  }
}

// 联系地址
export const validateAddress = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('请输入1到100位的联系地址'))
  } else if (value.length > 100 || value.length < 1) {
    callback(new Error('请输入1到100位的联系地址'))
  } else {
    callback();
  }
}

// 子账户
export const validateSubAccount = (rule, value, callback) => {
  if (!/^\w+$/.test(value)) {
    callback(new Error('账号只能由英文字母、数字和下划线组成'))
  } else {
    callback();
  }
}

// 子账户邮箱
export const validateSubEmail = (rule, value, callback) => {
  if (value.indexOf('@') === -1) {
    callback(new Error('4~40个字符,其中必须包含@'))
  } else {
    callback();
  }
}

// 深度取证次数
export const validateDeepForensicNum = (rule, value, callback) => {
  if (!/^[1-9]+[0-9]*]*$/.test(value)) {
    callback(new Error('深度取证次数只能输入正整数'))
  } else if (value.length > 5) {
    callback(new Error('深度取证次数最大为5位的正整数'));
  } else {
    callback();
  }
}
